import {
  EEventSearchType,
  IEventSearch,
} from '@/client/legacy-shared-modules/search/search-types';

import type { SearchAIResults_EventsByIds_eventsByIds_results } from '../../graphql-types/SearchAIResults_EventsByIds';
import {
  orderRecordsByIds,
  pickPlainTextOrDraftContent,
} from '../../utils/contentHelpers';

function inferEventSearchType(
  event: SearchAIResults_EventsByIds_eventsByIds_results
): EEventSearchType {
  if (event.__typename === 'ConferenceEventV2') {
    return EEventSearchType.CONFERENCE;
  }

  return EEventSearchType.SIMPLE;
}

export function mapEventsByIdsToEventHits(
  events: SearchAIResults_EventsByIds_eventsByIds_results[],
  orderedEventIds: string[]
): IEventSearch[] {
  return orderRecordsByIds(events, orderedEventIds).map((event) => {
    const descriptionPlainText = pickPlainTextOrDraftContent(
      null,
      event.description
    );

    return {
      scope: [],
      objectID: event._id,
      name: event.name ?? 'Event',
      descriptionPlainText:
        descriptionPlainText || event.shortDescription?.trim() || '',
      shortDescription: event.shortDescription ?? '',
      timeSpec: {
        startDate: event.startDate ?? '',
        endDate: event.endDate ?? '',
      },
      bannerImageUrl: event.bannerImage?.imageProxy ?? null,
      eventType: inferEventSearchType(event),
    };
  });
}
